import { render, staticRenderFns } from "./shiting.vue?vue&type=template&id=2d8d689a&scoped=true&"
import script from "./shiting.vue?vue&type=script&lang=js&"
export * from "./shiting.vue?vue&type=script&lang=js&"
import style0 from "./shiting.vue?vue&type=style&index=0&id=2d8d689a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d689a",
  null
  
)

export default component.exports